import React from 'react';
import { Instagram, Linkedin, Mail } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative border-t border-white/10 py-10 mt-10 z-10">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="font-typewriter text-xs uppercase tracking-[0.25em] text-white/55 flex items-center gap-3 flex-wrap justify-center">
            <span>© {currentYear}</span>
            <span className="text-white">Gal Harlavan</span>
            <span className="text-[color:var(--punk-red)]">·</span>
            <span>made with ink &amp; pixels</span>
          </div>

          <div className="flex items-center gap-6">
            <a
              href="https://www.instagram.com/evilnoodles666/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/55 hover:text-[color:var(--punk-red)] transition-colors hover:rotate-[-8deg] inline-block"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/55 hover:text-[color:var(--punk-red)] transition-colors hover:rotate-[8deg] inline-block"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
            <a
              href="mailto:gal.harlavan@gmail.com"
              className="text-white/55 hover:text-[color:var(--punk-red)] transition-colors hover:rotate-[-8deg] inline-block"
              aria-label="Email"
            >
              <Mail size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
